/** Supported application languages */
export enum Language {
  English = 'en',
  German = 'de',
}
